module.exports = __webpack_public_path__ + "static/media/world2meet.1fda4e5e.ico";